module.exports = __webpack_public_path__ + "static/media/RESIDENT.61341072.svg";